import { render, staticRenderFns } from "./personal-setting.vue?vue&type=template&id=696d4b56&scoped=true&"
import script from "./personal-setting.vue?vue&type=script&lang=js&"
export * from "./personal-setting.vue?vue&type=script&lang=js&"
import style0 from "./personal-setting.vue?vue&type=style&index=0&id=696d4b56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696d4b56",
  null
  
)

export default component.exports